import { IAppBarConfig, IAppBarMenuItem } from '@/interfaces';

// Common menu items that will be appended to all app bar configs
export const COMMON_APPBAR_MENU_ITEMS: IAppBarMenuItem[] = [
    {
        icon_url:
            'https://garage-prod.ackoassets.com/_next_static/garage-frontend-15/icons/help.svg',
        cta_text: 'Help',
        redirect_url:
            'https://ackodrive.com/service-centre/ad-services/schedule-callback',
    },
];

export const TRANSPARENT_APPBAR_CONFIG: IAppBarConfig = {
    back_button_color: '#FFFFFF',
    is_appbar_transparent: true,
};

export const CAR_SPA_APPBAR_CONFIG: IAppBarConfig = {
    background_color: '#033A14',
    back_button_color: '#FFFFFF',
    is_appbar_transparent: false,
    status_icon_brightness: 'light',
};

export const PICKUP_DROP_APPBAR_CONFIG: IAppBarConfig = {
    background_color: '#F8FDFF',
    back_button_color: '#121212',
    is_appbar_transparent: false,
    status_icon_brightness: 'dark',
};

export const DARK_THEME_APPBAR_CONFIG: IAppBarConfig = {
    background_color: '#121212',
    back_button_color: '#FFFFFF',
    is_appbar_transparent: false,
    status_icon_brightness: 'light',
};

export const UNKNOWN_ISSUE_APPBAR_CONFIG: IAppBarConfig = {
    background_color: '#f6f2fd',
    back_button_color: '#121212',
    is_appbar_transparent: false,
    status_icon_brightness: 'dark',
};

export const WELCOME_PAGE_APPBAR_CONFIG: IAppBarConfig = {
    background_color: '#1B3380',
    back_button_color: '#FFFFFF',
    is_appbar_transparent: false,
    status_icon_brightness: 'light',
};

export const POPUPS_APPBAR_CONFIG: IAppBarConfig = {
    background_color: '#808080',
    show_back_button: false,
    is_appbar_transparent: false,
    status_icon_brightness: 'light',
    menu_items: [],
};

export const LIGHT_THEME_APPBAR_CONFIG: IAppBarConfig = {
    background_color: '#FFFFFF',
    back_button_color: '#121212',
    is_appbar_transparent: false,
    status_icon_brightness: 'dark',
};

export const FAQ_PAGE_APPBAR_CONFIG: IAppBarConfig = {
    background_color: '#efe9fb',
    back_button_color: '#121212',
    is_appbar_transparent: false,
    status_icon_brightness: 'dark',
};
